import { CopyButton } from "@/Components/NextBase/CopyButton";
import {
  buildExternalBrowserIntentUrl,
  detectInAppBrowser,
} from "@/utils/inAppBrowser";
import { Button } from "@heroui/react";
import { Trans } from "@lingui/react/macro";
import { ExternalLink } from "lucide-react";
import { detectDevicePlatform } from "./registerRole";

/** A sign-up made in a social app's built-in browser does not carry over to the real one. */
export function InAppBrowserNotice() {
  const app = detectInAppBrowser(navigator.userAgent);

  if (!app) return null;

  const url = window.location.href;
  const intentUrl =
    detectDevicePlatform() === "android"
      ? buildExternalBrowserIntentUrl(url)
      : null;

  return (
    <div
      data-identifier="in-app-browser-notice"
      className="flex w-full flex-col items-start gap-2 rounded-xl border border-warning/40 bg-warning/10 p-3 text-foreground text-sm"
    >
      <p className="font-medium">
        <Trans>Za registracijo odpri stran v svojem brskalniku.</Trans>
      </p>
      {intentUrl ? (
        <Button
          as="a"
          href={intentUrl}
          size="sm"
          color="primary"
          startContent={<ExternalLink size={16} />}
          data-identifier="in-app-browser-open"
        >
          <Trans>Odpri v brskalniku</Trans>
        </Button>
      ) : (
        <>
          <p className="text-foreground-600">
            <Trans>
              Tapni ⋯ zgoraj desno in izberi »Open in external browser« ali pa
              kopiraj povezavo in jo prilepi v brskalnik.
            </Trans>
          </p>
          <CopyButton text={url} size="sm" variant="tertiary">
            <Trans>Kopiraj povezavo</Trans>
          </CopyButton>
        </>
      )}
    </div>
  );
}
